import { AxiosInstance } from "axios"
import { DeviceMerchantAdmin } from "./adminDevicesTypes"

type AllDevicesParams = Readonly<{ merchantId: number }>

export type DevicesMerchantAdminResponse = Readonly<{
    devices: DeviceMerchantAdmin[]
}>

export async function fetchAllDevices(
    { merchantId }: AllDevicesParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<DevicesMerchantAdminResponse> {
    const response = await axios.get(`/merchants/${merchantId}/devices`)
    return response.data
}
